import { render, staticRenderFns } from "./ReviewModifyView.vue?vue&type=template&id=58769712&"
import script from "./ReviewModifyView.vue?vue&type=script&lang=js&"
export * from "./ReviewModifyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports